export default "__VITE_ASSET__rW6VFTVQ__"